import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserDeals from './user-deals';
import UserDealsDetail from './user-deals-detail';
import UserDealsUpdate from './user-deals-update';
import UserDealsDeleteDialog from './user-deals-delete-dialog';

const UserDealsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserDeals />} />
    <Route path="new" element={<UserDealsUpdate />} />
    <Route path=":id">
      <Route index element={<UserDealsDetail />} />
      <Route path="edit" element={<UserDealsUpdate />} />
      <Route path="delete" element={<UserDealsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserDealsRoutes;
